var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useEffect, useRef } from 'react';
import { apiUpdateProffitSearchSlideUploadCompleteViewAt, apiGetOneProffitSearchSlideUploadGroup, } from '../../../../actions/ProffitSearchAction';
import { apiGetOneProffitSearchInformationTop, hideProffitSearchInformationTopModalComplete, hideProffitSearchInformationTopModalProgress, showProffitSearchInformationTopModalComplete, updateProffitSearchInformationTopModalProgress, } from '../../../../actions/ProffitSearchInformationTopAction';
import { wrapDispatch } from '../../../action';
import { useDidMount } from '../../useHook';
/**
 * スライドの追加処理
 * @param options
 * @returns {{hideUploadProgressModal: ((function(): void)|*), hideUploadCompleteModal: ((function(): Promise<void>)|*), onChange: ((function(*): Promise<void>)|*), uploadingApis: {progress: *, id: *}[]}}
 */
const useSlideAdd = (options) => {
    const { dispatch, proffitSearchInformationTop, slideSearchSlideUpload, unmountRef, } = options;
    const { currentUploadGroupId, information, modalInformation: { pageCount, progress, showCompleteModal, showProgressModal, tagSetPageCount, }, } = proffitSearchInformationTop;
    const { slides } = information;
    useEffect(() => () => {
        // ページ離脱する際にモーダルは全て閉じる
        dispatch(hideProffitSearchInformationTopModalProgress(null, true));
        dispatch(hideProffitSearchInformationTopModalComplete());
    }, [dispatch]);
    /**
     * ファイルが選択された際、アップロードとモーダル表示の制御を行うイベント
     * @type {(function(*): Promise<void>)|*}
     */
    const onChange = useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        if (!e.currentTarget.files.length) {
            return;
        }
        const argSlides = Array.from(e.currentTarget.files).map((v) => ({
            file: v,
        }));
        e.currentTarget.value = '';
        yield slideSearchSlideUpload({
            dispatch,
            slides: argSlides,
            unmountRef,
        });
    }), [dispatch, unmountRef, slideSearchSlideUpload]);
    /**
     * アップロード中モーダルを閉じる
     * @type {(function(): void)|*}
     */
    const hideProgressModal = useCallback(() => {
        dispatch(hideProffitSearchInformationTopModalProgress(null, true));
    }, [dispatch]);
    /**
     * 完了モーダルを閉じる
     * @type {(function(): Promise<void>)|*}
     */
    const hideCompleteModal = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(hideProffitSearchInformationTopModalComplete());
        // 現時点で未読のデータを全て既読に更新する
        yield wrapDispatch(dispatch, apiUpdateProffitSearchSlideUploadCompleteViewAt());
        yield wrapDispatch(dispatch, apiGetOneProffitSearchInformationTop());
    }), [dispatch]);
    const slideRef = useRef();
    slideRef.current = slides;
    const topRef = useRef();
    topRef.current = proffitSearchInformationTop;
    const isProgressEnd = progress >= 100;
    const isUploadPollingComplete = pageCount && tagSetPageCount && pageCount === tagSetPageCount;
    const showCompleteModalByTopApi = useCallback((payload) => {
        const { completedSlides: { totalNewConvertCount, totalNewTagCount }, } = payload;
        const { modalInformation: { showProgressModal: isShowProgressModal }, } = topRef.current;
        if (!isShowProgressModal && totalNewConvertCount) {
            dispatch(showProffitSearchInformationTopModalComplete({
                addAllTagsCount: totalNewTagCount,
                pageCount: totalNewConvertCount,
            }));
        }
    }, [dispatch, topRef]);
    // 初回起動時の完了modal表示
    useDidMount(() => {
        // 完了済みがあれば表示
        showCompleteModalByTopApi(information);
    }, [showCompleteModalByTopApi, information]);
    // modal非表示中の最新状態の取得
    useEffect(() => {
        let doing = false;
        const interval = setInterval(() => {
            // 処理中のファイルがある場合
            const hasDoingFile = !!(slideRef.current || []).find((row) => {
                const { completeAt } = row;
                return !completeAt;
            });
            const runApi = !showProgressModal && !showCompleteModal && hasDoingFile && !doing;
            if (!runApi) {
                return;
            }
            doing = true;
            wrapDispatch(dispatch, apiGetOneProffitSearchInformationTop())
                .then(({ payload }) => {
                if (unmountRef.current) {
                    return;
                }
                // 完了モーダルの表示
                showCompleteModalByTopApi(payload);
            })
                .finally(() => {
                doing = false;
            });
        }, 3000);
        return () => {
            clearInterval(interval);
        };
    }, [
        dispatch,
        slideRef,
        unmountRef,
        showProgressModal,
        showCompleteModal,
        showCompleteModalByTopApi,
    ]);
    // modal表示中の最新状態の取得
    useEffect(() => {
        let doing = false;
        const interval = setInterval(() => {
            const runApi = showProgressModal &&
                !showCompleteModal &&
                isProgressEnd &&
                !isUploadPollingComplete &&
                !doing;
            if (!runApi) {
                return;
            }
            doing = true;
            const uploadGroupAction = apiGetOneProffitSearchSlideUploadGroup(currentUploadGroupId);
            wrapDispatch(dispatch, uploadGroupAction)
                .then(({ payload }) => {
                if (unmountRef.current) {
                    return;
                }
                const isCompleteAfterApi = payload.pageCount &&
                    payload.tagSetPageCount &&
                    payload.pageCount === payload.tagSetPageCount;
                const setModalInformation = {
                    addAllTagsCount: payload.tagSetPageCount,
                    pageCount: payload.pageCount,
                };
                if (isCompleteAfterApi) {
                    // 最新情報の取得
                    dispatch(apiGetOneProffitSearchInformationTop());
                    // 完了モーダルに切り替え
                    dispatch(showProffitSearchInformationTopModalComplete(setModalInformation));
                }
                else {
                    // 現在の状態を更新
                    dispatch(updateProffitSearchInformationTopModalProgress(null, currentUploadGroupId, setModalInformation));
                }
            })
                .finally(() => {
                doing = false;
            });
        }, 3000);
        return () => {
            clearInterval(interval);
        };
    }, [
        dispatch,
        currentUploadGroupId,
        showProgressModal,
        showCompleteModal,
        isUploadPollingComplete,
        isProgressEnd,
        unmountRef,
    ]);
    return {
        hideUploadCompleteModal: hideCompleteModal,
        hideUploadProgressModal: hideProgressModal,
        onChange,
        uploadProgress: progress,
    };
};
export const useSlideSearchTop = {
    useSlideAdd,
};
export default useSlideSearchTop;
